



























































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import DetailsList from '@/views/error-monitor/error-monitor-details-list.component.vue';
import ContextViewer from '@/views/error-monitor/error-monitor-context-viewer.component.vue';
import ButtonReprocessIgnore from '@/shared/button/button.component.vue';
import EventErrorService from '@/domain/event/event-error.service';
import EventError from '@/domain/event/event-error.entity';
import snackbarService from '@/shared/snackbar/snackbar.service';

@Component({
  components: {
    DetailsList,
    ButtonReprocessIgnore,
    ContextViewer,
  },
})
export default class ErrorModal extends Vue {
  @Prop() details!: EventError[];

  @Prop() titleModal!: string;

  @Prop(Boolean) private dialog?: boolean;

  private loading: boolean = false;

  private eventErrorService = new EventErrorService();

  private context: string = '';

  private date?: Date;

  close() {
    this.$emit('close');
  }

  async reprocess() {
    this.loading = true;
    try {
      await this.eventErrorService.reprocessAndDeleteError(this.details[0].id);
      snackbarService.successMessage(this.$t('errorReprocess'));
    } catch (err) {
      snackbarService.errorMessage(err);
    } finally {
      this.loading = false;
      this.close();
      this.$emit('refresh');
    }
  }

  contextDisplay(context:string, date: Date) {
    this.context = context;
    this.date = date;
  }

  @Watch('details')
  onDetailsChanged() {
    this.contextDisplay(this.details[0].errorContext, this.details[0].eventDate);
  }
}
